import API_BASE_URL from "./RestAPI";

const BASE = `${API_BASE_URL.replace(/\/$/, "")}/ticketing`;

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

export const sprintApi = {
    // One status for several bugs. followParentId: the bugs are following that
    // story to the status it now has (the only way into Production under release approval).
    bulkBugStatus: async (ticketIds, statusId, followParentId = null) => {
        const res = await fetch(`${BASE}/ticket/bulk-status/`, {
            method: "POST", headers: getAuthHeaders(),
            body: JSON.stringify({ ticket_ids: ticketIds, status_id: statusId, follow_parent_id: followParentId }),
        });
        return res.json();
    },

    // ── Sprint-level move-to-live requests ──
    // Stories of the sprint that can be requested now ('eligible') and the rest with a reason ('excluded').
    liveMoveCandidates: async (sprintId, signal) => {
        const res = await fetch(`${BASE}/live-move/bulk-request/?sprint_id=${sprintId}`, { headers: getAuthHeaders(), signal });
        return res.json();
    },

    // All or nothing: on "fail", data.blocked lists the tickets that stopped it.
    raiseLiveMoveRequests: async (sprintId, ticketIds, requestNote) => {
        const res = await fetch(`${BASE}/live-move/bulk-request/`, {
            method: "POST", headers: getAuthHeaders(),
            body: JSON.stringify({ sprint_id: sprintId, ticket_ids: ticketIds, request_note: requestNote }),
        });
        return res.json();
    },

    // ── Comments: files, author-only edit, edit history ──
    // Multipart so files can ride along; the browser sets the boundary header.
    addComment: async (ticketId, text, files = [], parentCommentId = null) => {
        const form = new FormData();
        form.append("ticket_id", ticketId);
        form.append("comments", text || "");
        form.append("is_parent_comment", parentCommentId ? "false" : "true");
        if (parentCommentId) form.append("parent_comment_id", parentCommentId);
        files.forEach(f => form.append("files", f));
        const headers = getAuthHeaders();
        delete headers["Content-Type"];
        const res = await fetch(`${BASE}/comments/`, { method: "POST", headers, body: form });
        return res.json();
    },

    editComment: async (commentId, text, files = [], removeAttachmentIds = []) => {
        const form = new FormData();
        form.append("id", commentId);
        form.append("comments", text || "");
        removeAttachmentIds.forEach(id => form.append("remove_attachment_ids", id));
        files.forEach(f => form.append("files", f));
        const headers = getAuthHeaders();
        delete headers["Content-Type"];
        const res = await fetch(`${BASE}/comments/`, { method: "PUT", headers, body: form });
        return res.json();
    },

    // Author only; replies and files go with it.
    deleteComment: async (commentId) => {
        const res = await fetch(`${BASE}/comments/?id=${commentId}`, { method: "DELETE", headers: getAuthHeaders() });
        return res.json();
    },

    commentHistory: async (commentId) => {
        const res = await fetch(`${BASE}/comments/history/?id=${commentId}`, { headers: getAuthHeaders() });
        return res.json();
    },

    // A fresh link for one comment file (list links expire after 10 minutes).
    commentFileUrl: async (commentId, attachmentId) => {
        const res = await fetch(`${BASE}/comments/?attachment_id=${attachmentId}`, { headers: getAuthHeaders() });
        const data = await res.json();
        if (data.status !== "success" || !data.data) throw new Error(data.message || "Could not get the file");
        return data.data;
    },
};